import { useState, useEffect, useCallback } from 'react'

const STORAGE_KEY = 'sst-theme'

const themes = ['electric', 'sunset', 'rose', 'neon', 'coral', 'forest'] as const

export type Theme = (typeof themes)[number]

function getInitialTheme(): Theme {
  const saved = localStorage.getItem(STORAGE_KEY)
  if (saved && (themes as readonly string[]).includes(saved)) {
    return saved as Theme
  }
  return 'electric'
}

function applyTheme(t: Theme) {
  document.documentElement.dataset.theme = t
  localStorage.setItem(STORAGE_KEY, t)
}

applyTheme(getInitialTheme())

export function useTheme() {
  const [theme, setThemeState] = useState<Theme>(getInitialTheme)

  useEffect(() => {
    applyTheme(theme)
  }, [theme])

  const setTheme = useCallback((t: Theme) => {
    setThemeState(t)
  }, [])

  return { theme, setTheme, themes }
}
